import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ENTREPRISE } from '../data/site';

function majBalise(selecteur, attrs) {
  let el = document.head.querySelector(selecteur);
  if (!el) {
    el = document.createElement(attrs.rel ? 'link' : 'meta');
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
}

export default function Seo({ titre, description, jsonLd, noindex = false }) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (titre) document.title = titre;
    if (description) {
      majBalise('meta[name="description"]', { name: 'description', content: description });
      majBalise('meta[property="og:description"]', { property: 'og:description', content: description });
    }
    if (titre) majBalise('meta[property="og:title"]', { property: 'og:title', content: titre });
    majBalise('link[rel="canonical"]', { rel: 'canonical', href: ENTREPRISE.site + pathname });

    // Les pages reservees ne doivent jamais entrer dans l'index de Google.
    const robots = document.head.querySelector('meta[name="robots"]');
    if (noindex) {
      majBalise('meta[name="robots"]', { name: 'robots', content: 'noindex, nofollow' });
    } else if (robots) {
      robots.remove();
    }

    const id = 'jsonld-page';
    const ancien = document.getElementById(id);
    if (ancien) ancien.remove();
    if (jsonLd) {
      const s = document.createElement('script');
      s.type = 'application/ld+json';
      s.id = id;
      s.text = JSON.stringify(jsonLd);
      document.head.appendChild(s);
    }
  }, [titre, description, jsonLd, pathname, noindex]);

  return null;
}
